"use strict";
var React = require('react')
var Link = require('react-router')
var Navigation = require('../Navigation/Navigation')

var Desavanje = React.createClass({
  render() {
    return (
      <div className='col-margin-top'>
        <h1>Welcome</h1>
        <div className='col-md-4'>
            Movie Database for personal use.
        </div>

      </div>
    )
  }
})

module.exports = Desavanje;



/** WEBPACK FOOTER **
 ** ./modules/components/Desavanje/Desavanje.js
 **/